






























































import Vue from 'vue';
import { EventBus } from '@/plugins/event-bus';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import MobileNavigationDrawer from '@/components/header/MobileNavigationDrawer.vue'; // @ is an alias to /src

@Component({
  components: {
    MobileNavigationDrawer,
  },
})
export default class Header extends Vue {
    // init data
    public fixed: boolean = false;
    public right: boolean = true;
    public title: string = 'LUX TAG';
    public showDrawer: boolean = false;
    public showAvatar: boolean = true;
    public showDrowpdownLost = false;
    public activeTab = 0;
    public hideSlider = false;
    public showTabActiveColor = true;

    public NavigationList: any[] = [
        {
            key: 1,
            name: 'FAQ',
            path: '/faq',
            outline: true,
            round: true,
            color: 'primary',
            class: {
                'white--text': false,
                'hidden-xs-only': true,
            },
        },
        {
            key: 2,
            name: 'Register',
            path: '/register',
            outline: false,
            round: true,
            color: 'primary',
            class: {
                'white--text': true,
                'hidden-xs-only': true,
            },
        },
    ];


    public created() {
        EventBus.$on('change-active-tab', (activeTab: number) => {
            this.activeTab = activeTab;
        });

        EventBus.$on('change-hide-slider', (hideSlider: boolean) => {
            this.hideSlider = hideSlider;
        });

        EventBus.$on('change-show-tab-active-color', (showTabActiveColor: boolean) => {
            this.showTabActiveColor = showTabActiveColor;
        });
    }

    // public menuDropDownClick(menu: string) {
    //     // close the dropdown manually
    //     this.showDrowpdownLost = false;

    //     // execute the choice
    //     if (menu === 'profile') {
    //         this.$router.push('/profile');
    //     } else if (menu === 'logout') {
    //         this.logout();
    //     }
    // }

    // public logout() {
    //     this.$store.commit('MUTATE_AUTH', {
    //         login: false,
    //     });
    //     this.$router.replace('/login');
    // }

    public onTabNavigationClick(key: string) {
        switch (key) {
            case 'home':
                break;
            case 'login':
                break;
            case 'login':
                break;

        }
    }

    public onNavigationClick(path: string) {
        this.$router.push(path);
    }

    public back() {
        this.showDrawer = false;
        this.$router.push('/event');
    }

    get isShowNavigation(): any {
        return this.$store.getters.getShowNavigation;
    }
    get getTitle(): any {
        return this.$store.getters.getTitle;
    }
    get getHeaderStyle(): any {
        return this.$store.getters.getHeaderStyle;
    }
}
